import { render, staticRenderFns } from "./editMedia.vue?vue&type=template&id=706497c2"
import script from "./editMedia.vue?vue&type=script&lang=js"
export * from "./editMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports